<tic-home-banner></tic-home-banner>
<tic-search-form-panel (onSubmitDetails)="onSubmitForm($event)"></tic-search-form-panel>
<section class="category-cards">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2 class="text-center">{{'homePage.categorySection.title' | i18n}}</h2>
        <p class="text-center">{{'homePage.categorySection.catTagLine' | i18n}}</p>
      </div>
    </div>
    <tic-offer-services [itemList]="this.offerServicesList"></tic-offer-services>
  </div>
</section>
<section class="booking-sect">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-6 img_col">
        <img src="assets/images/Isolation_Mode.png" />
      </div>
      <div class="col-lg-6 blurb col-md-6">
        <p class="tag">{{'homePage.bookingSection.booking' | i18n}}</p>
        <h2 class="title">{{'homePage.bookingSection.title' | i18n}}</h2>
        <p class="description">{{'homePage.bookingSection.description' | i18n}}
        </p>
        <a href="#" class="button">{{'homePage.bookingSection.bookTrip' | i18n}}</a>
      </div>
    </div>
  </div>
</section>
<section class="best-hotels">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2 class="text-center">{{'homePage.hotelSection.title' | i18n}}</h2>
        <p class="text-center">{{'homePage.hotelSection.hotelTagLine' | i18n}}</p>
      </div>
    </div>
    <tic-top-hotel-carousel [itemList]="this.topHotelList"></tic-top-hotel-carousel>
  </div>
</section>
<section class="best-hotels best-events">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2 class="text-center">{{'homePage.eventSection.title' | i18n}}</h2>
        <p class="text-center">{{'homePage.eventSection.eventTagLine' | i18n}}</p>
      </div>
    </div>
    <tic-event-carousel [itemList]="this.topEventsList"></tic-event-carousel>
  </div>
</section>
<section class="testimonials">
  <div class="container position-relative">
    <h4 class="text-center">{{'homePage.testimonialSection.title' | i18n}}</h4>
    <h1 class="text-center">{{'homePage.testimonialSection.testimonialTagLine' | i18n}}</h1>
    <tic-testimonial [itemList]="this.testimonialList"></tic-testimonial>
  </div>
</section>
<tic-how-works></tic-how-works>
